import { CurrentDueDay, NonSelectable, Selectable, Selected } from '../utils/subcomponents';
const getGridItemComponent = ({ day, currentDueDay, eligibleDueDays, selectedDay }) => {
    const isCurrentDueDay = day === currentDueDay;
    const isEligibleDueDay = eligibleDueDays?.some(eligibleDay => eligibleDay.eligibleDueDay === day);
    const isSelected = day === selectedDay;
    const componentMap = {
        Selected: isSelected,
        CurrentDueDay: isCurrentDueDay,
        Selectable: isEligibleDueDay,
        NonSelectable: !(isSelected || isCurrentDueDay || isEligibleDueDay)
    };
    const componentName = Object.keys(componentMap).find((key) => componentMap[key]) || 'NonSelectable';
    return {
        GridItem: { Selected, CurrentDueDay, Selectable, NonSelectable }[componentName],
        componentName
    };
};
export default getGridItemComponent;
